var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRowsDropdown(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 12,
    viewBox: "0 0 12 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6 7.7L3 4.7L3.7 4L6 6.3L8.3 4L9 4.7L6 7.7Z",
    fill: "#3D3D3B"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRowsDropdown);
export default __webpack_public_path__ + "static/media/rows-dropdown.f4907a64532f5a5c4aacbe5230f88294.svg";
export { ForwardRef as ReactComponent };